import { atom } from 'jotai';
import { SystemStatItem } from '../../data/datamonitorRepo';

export type SystemState = {
    init: boolean;
    waiting: boolean;
    error: string | null;
    system: SystemStatItem[];
    integrity: SystemStatItem[];
};

export const systemStateAtom = atom<SystemState>({
    init: true,
    waiting: false,
    error: null,
    system: [],
    integrity: [],
});
